import NegativeMessage from '../../../../../assets/input/negative-information.png';
import { InputField } from '../../../UI/Input/InputField';

const SwiftDataFields = ({
  swiftCode,
  hadnleSwiftCodeFn,
  ibanCode,
  hadnleIbanCodeFn,
  ibanCodeValidationMessage,
  swiftCodeValidationMessage,
  showModify,
}: {
  swiftCode?: string;
  hadnleSwiftCodeFn: (event: any) => void;
  ibanCode?: string;
  hadnleIbanCodeFn: (event: any) => void;
  ibanCodeValidationMessage: string | null;
  swiftCodeValidationMessage: string | null;
  showModify: boolean;
}) => {
  return (
    <div>
      <InputField
        label="Swift / BIC code"
        id="identifier"
        forId="identifier"
        type="text"
        value={swiftCode}
        className=" mb-3"
        onChange={hadnleSwiftCodeFn}
        readOnly={!showModify}
      />
      {swiftCodeValidationMessage && (
        <div className="-mt-1..5 mb-1">
          <div className="flex items-center">
            <img src={NegativeMessage} alt="" className="w-auto h-auto max-w-6 max-h-6" />
            <span className="font-Sweet text-Caption1inline-block align-baseline text-xs ml-2">{swiftCodeValidationMessage}</span>
          </div>
        </div>
      )}
      <InputField
        label="IBAN / Account number"
        id="account number"
        forId="account number"
        type="text"
        value={ibanCode}
        className="mb-3"
        onChange={hadnleIbanCodeFn}
        readOnly={!showModify}
      />
      {ibanCodeValidationMessage && (
        <div className="-mt-1..5">
          <div className="flex items-center">
            <img src={NegativeMessage} alt="" className="w-auto h-auto max-w-6 max-h-6" />
            <span
              dangerouslySetInnerHTML={{ __html: `<p>${ibanCodeValidationMessage}</p>` }}
              className="font-Sweet text-Caption1inline-block align-baseline text-xs ml-2"></span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SwiftDataFields;
